import React from "react";
import FadeSection from "./utils/anim";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import portfolioContent from "./data/portfolioData";
import ReactGA from 'react-ga4';

function Portfolio({ lightMode }){
    
    const [isActive, setIsActive] = React.useState("Web Design");
    const portfolioRef = React.useRef([]);
    const [movingStyle, setMovingStyle ] = React.useState({});
    const [isAnimating, setIsAnimating] = React.useState(false);
    const [displayTab, setDisplayTab] = React.useState("Web Design");
    const [maxItem, setMaxItem] = React.useState(3);
    const [imageLoading, setImageLoading] = React.useState(true);
    
    
    const handleTabChange = (tab) =>{

        if(tab === isActive) {
            return
        }
        setIsAnimating(true);
        setIsActive(tab);
        setMaxItem(3);

        ReactGA.event({
            category: 'PortfolioTab',
            action:'Click',
            label:'portfolio'
        })

        
        // Wait for scale down animation before changing content
        setTimeout(() => {
            setDisplayTab(tab);
            // Then trigger scale up animation
            setTimeout(() => {
              setIsAnimating(false);
            }, 50);
          }, 300);
    }

    const handleImageLoad = () =>{
            setImageLoading(false);        
    }

    const moreItem = () =>{
        setMaxItem(prevItem => prevItem + 3);
    }

    const portfoliocontact = () =>{
        window.open("mailto:maayilniyas@gmail.com")
    }

    React.useEffect(() =>{
        const currentTab = portfolioRef.current[isActive];
        if(currentTab){
            
            setMovingStyle({
                left: `${currentTab.offsetLeft}px`,
                width: `${currentTab.offsetWidth}px`,
                height: `${currentTab.offsetHeight}px`,
            });
        }
    },[isActive]);
    //const allSkills = Object.values(portfolioContent).map()
    
    return(
        <>
        <div className={` ${lightMode ? "custom-project-bg-light":"custom-project-bg"} min-h-screen`}> 
            <div className="py-10 px-4 min-h-full max-w-7xl mx-auto ">
                <FadeSection effect="fade-right">
                    <div className="w-full">
                    <h1 className={`text-4xl leading-normal ${lightMode ? "works-title-light":"works-title"} text-left font-bold bg-gradient-to-r from-violet-900 to-violet-400 bg-clip-text text-transparent`}>My Recent works</h1>
                    </div>
                </FadeSection>
                <div className="w-full">
                <FadeSection effect="fade-in-down">
                    <div className="mt-5 rounded-full px-2 py-2  inline-block  bg-zinc-950">
                        <div className=" flex justify-center gap-2 md:gap-3 duration-300  ease-in-out">
                        <div className="absolute transition-all duration-700 ease rounded-full third-color-bg"  style={movingStyle} />
                            {
                                Object.keys(portfolioContent).map((tab) =>(
                                <button
                                    ref={el => portfolioRef.current[tab] = el}
                                    key={tab}
                                    onClick={() => handleTabChange(tab)}
                                    className={` px-3 md:px-6 py-1 md:py-2 rounded-full text-lg relative font-medium z-10 duration-300 transition-all
                                        ${isActive === tab ? 'text-white' :'text-gray-300 hover:text-white hover:bg-gray-700' }
                                    `}
                                >
                                {tab}
                                </button>))
                            }
                        </div>
                    </div>
                    </FadeSection>
                </div>
                <div className="w-full mt-10 mx-auto overflow-hidden">
                    
                    <div className="relative mx-auto">
                        <div className={` grid-cols-1 md:grid-cols-2 ${portfolioContent[displayTab].items.length <= 2? 'lg:grid-cols-2':'lg:grid-cols-3' }  grid gap-8 transition-all duration-300 transform
                            ${isAnimating ? 'scale-95 opacity-0': 'scale-100 opacity-100'}`}>
                                 
                                {portfolioContent[displayTab].items.slice(0,maxItem).map(( item, index)  =>(
                                <div key={index} className={`p-6 ${lightMode ? "bg-gray-900":"bg-gray-700/50"} text-white rounded-lg hover:bg-gray-600/60 transition-all duration-300`}>
                                        <h3 className="text-lg font-semibold mb-2">{item.title}</h3>
                                        <p className="text-gray-400">{item.description}</p>
                                        {item.info && 
                                        (<div className="text-white text-left">
                                            {item.info}
                                        </div>  )}
                                        <div className="flex items-center mt-2" >
                                            {item.image && (<img src={item.image} alt={item.alt} onLoad={handleImageLoad} className={`transition-opacity ${imageLoading ? "animate-pulse opacity-75":"opacity-100"} rounded-tl-2xl rounded-br-2xl`}/>)}
                                        </div>
                                        <div className="mt-6 h-full">
                                            {Object.keys(item.skill_used).length > 0 && 
                                               (<div className="text-md ">                                   
                                                    <h2 className="  text-left font-semibold">Skills used </h2> 
                                                    <div className="flex justify-start flex-wrap gap-x-4"> 
                                                    {Object.keys(item.skill_used).map((skey) =>(
                                                        <div key={skey} className=" inline-flex items-center gap-y-3 gap-x-4 mt-2 ">
                                                             
                                                            {item.skill_used[skey].map((skill, idx) => (
                                                                <div key={idx} className="min-w-[60px]">
                                                                    <div className="rounded-3xl p-[7px_5px_5px] bg-[#140c1c] shadow-[0_2px_15px_-3px_rgba(0,0,0,0.07),0_10px_20px_-2px_rgba(0,0,0,0.04)] border-transparent mb-[5px] transition-all duration-600 border-2">
                                                                        {skey === 'custicons' ? (<img src={skill} className="mx-auto " alt="SEO" />) : (<FontAwesomeIcon key={idx} className="third-color" size="2x" icon={skill} />)}
                                                                    </div>
                                                                   
                                                                </div>
                                                            ))}
                                                               
                                                        </div>
                                                        )) }
                                                         {/*item.skill_name && (<p className="text-xs">{item.skill_name}</p>)*/}
                                                    </div>
                                                </div>
                                            )}
                                            {item.links && (
                                                
                                                <div className="mt-6">
                                                    <a href={item.links} rel="noreferrer" target="_blank" className="third-color-bg px-3 text-base font-semibold py-2 rounded-[10px]">View Site</a>
                                                </div>
                                                
                                                )}
                                        </div>
                                    </div>  
                                    
                                ))}
                                
                        </div>
                        
                    </div>
                    
                    {portfolioContent[displayTab].items.length > maxItem && (
                        <FadeSection effect="fade-in-up" duration="duration-[700ms]">
                            <div className="flex justify-center my-5 items-center">
                                <button onClick={moreItem} className="third-color-bg text-white my-5 rounded-full px-2 py-2">View More</button>
                            </div>
                        </FadeSection>
                    )}

                    {portfolioContent[displayTab].links && (
                    <FadeSection effect="fade-in-up" duration="duration-[1000ms]">
                        <div className="block my-5 w-4/5 rounded-[15px] mx-auto p-4 md:pl-12 md:pr-12 bg-gradient-to-r from-teal-600 to-blue-700">
                            <div className="flex justify-between items-center ">
                                <p className="text-xl font-bold">To know more about the projects</p>
                                <button className="third-color-bg font-semibold text-white rounded-[15px] px-2 py-2" onClick={portfoliocontact}>Contact Me</button>
                            </div>
                        </div>
                    </FadeSection>
                    )}
                </div>
            </div>
        </div>
        </>
    );
}

export default Portfolio;